export default __webpack_public_path__ + "media/images/ico/favicon-32-b5cb2701de347c25633d98d92e464251.png";